import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_generic_doc_custom_processing_history_RowClass } from "../../../dbschema";

export class GenericDocCustomProcessingHistoryContainerModel extends BaseContainerModel{
  bl_fi_generic_doc_custom_processing_history: bl_fi_generic_doc_custom_processing_history_RowClass = new bl_fi_generic_doc_custom_processing_history_RowClass();
}